import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

import globals from '../../../../lib/globals/globals';
import getJson from '../../../../lib/network/get-json';
import logger from '../../../../lib/logger/logger';
import NavigationItemRecord from '../../../../lib/records/NavigationItemRecord';

var getNavigationItem = function getNavigationItem(navigationResponse) {
  var _ref = navigationResponse.linkNavigationViewBean || navigationResponse || {},
      displayType = _ref.displayType,
      url = _ref.url,
      browserMode = _ref.browserMode,
      confirmRequired = _ref.confirmRequired,
      _ref$linkStaticConfig = _ref.linkStaticConfig,
      linkStaticConfig = _ref$linkStaticConfig === void 0 ? {} : _ref$linkStaticConfig;

  var _linkStaticConfig$lin = linkStaticConfig.linkNonSamlAttributes,
      linkNonSamlAttributes = _linkStaticConfig$lin === void 0 ? {} : _linkStaticConfig$lin,
      _linkStaticConfig$lin2 = linkStaticConfig.linkSamlAttributes,
      linkSamlAttributes = _linkStaticConfig$lin2 === void 0 ? {} : _linkStaticConfig$lin2;
  var linkAttribute = displayType === 'saml' ? linkSamlAttributes : linkNonSamlAttributes;
  var navigationUrl = url;
  var deviceFeature = '';

  if (linkSamlAttributes['data-device-feature']) {
    deviceFeature = linkSamlAttributes['data-device-feature'];
  }

  return new NavigationItemRecord({
    navigationUrl: navigationUrl,
    displayType: displayType,
    nativeNavigationType: 'external',
    deviceFeature: deviceFeature,
    externalNavigation: 'external' === linkAttribute['data-link-type'] || confirmRequired === 'confirm-dispatch',
    forceWindow: 'true' === linkAttribute['data-force-window'] || browserMode === 'externalBrowser'
  });
};
/**
 * Callback function used to close the chatbot. It checks the uuid sent by the childframe with the stored chatbotId and also checks that the event type is 'exitChat' before calling the bridge to remove the child frame.
 *
 * @param {Object} ev - event from chatbot containing the close event type and uuid.
 * @param {Object} ev.data - data being passed by the chatbot to the M2 application
 * @param {string} ev.data.type - type of event being sent by the chatbot. Should be 'exitChat'.
 * @param {string} ev.data.uuid - uuid of the chatbot frame.
 */


export var navigateCallback = function navigateCallback(_ref2) {
  var _ref2$data = _ref2.data,
      type = _ref2$data.type,
      uuid = _ref2$data.uuid,
      _ref2$data$payload = _ref2$data.payload,
      identifier = _ref2$data$payload.identifier,
      externalLinkData = _ref2$data$payload.externalLinkData;

  if (type === 'navigate' && uuid && window.WF_CHATBOT.uuid === uuid) {
    var navigationItem;

    if (typeof identifier === 'string') {
      var deeplink = globals().wfBotAssistantNavigateUrl ? globals().wfBotAssistantNavigateUrl : '';
      getJson({
        url: deeplink,
        includeRootContext: false,
        params: {
          identifier: identifier
        }
      }).then(function (response) {
        navigationItem = getNavigationItem(response);
        window.WF_CHATBOT.navigate(navigationItem);
      })["catch"](function (response) {
        logger.error(response);
        var _response$FailureMess = response.FailureMessageBean,
            FailureMessageBean = _response$FailureMess === void 0 ? {} : _response$FailureMess;
        var category = FailureMessageBean.category,
            failureMessage = FailureMessageBean.failureMessage;
        window.WFUI_BRIDGE.postMessageToChildren(window.WF_CHATBOT.uuid, {
          type: 'error',
          payload: {
            errorType: category,
            errorMessage: failureMessage
          }
        });
      });
    } else if (_typeof(externalLinkData) === 'object') {
      navigationItem = getNavigationItem(externalLinkData);
      window.WF_CHATBOT.navigate(navigationItem);
    }
  }
};
/**
 * Adds event listener to navigate to a different page.
 */

export var addNavigateEvent = function addNavigateEvent() {
  window.WFUI_BRIDGE.registerEventListener('navigate', navigateCallback, window.WF_CHATBOT.uuid);
};